import React, { useState, useEffect, useMemo } from "react";

import { useParams,useNavigate  } from "react-router-dom";
import { Search } from "lucide-react";
import {
    CalendarDays,
    MapPin,
    Building2,
    Users,
    ArrowRight,
    UserRound,
    Mail,
} from "lucide-react";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import API_BASE_URL from "../../api/api";


const AboutPage = () => {
    const { slug } = useParams();
    const [academicMembers, setAcademicMembers] = useState([]);
    const [academicLoading, setAcademicLoading] = useState(true);
    const [academicError, setAcademicError] = useState("");
    const [executiveMembers, setExecutiveMembers] = useState([]);
    const [executiveLoading, setExecutiveLoading] = useState(true);
    const [executiveError, setExecutiveError] = useState("");
    const navigate = useNavigate();
    // acedmic council start code
    // Academic Council API
    useEffect(() => {
        const fetchMembers = async () => {
            try {
                const response = await fetch(
                    `${API_BASE_URL}/academic-council`
                );

                if (!response.ok) {
                    throw new Error("Failed to fetch Academic Council data.");
                }

                const result = await response.json();

                setAcademicMembers(
                    result.success && Array.isArray(result.data)
                        ? result.data
                        : []
                );
            } catch (err) {
                console.error("Academic Council API Error:", err);
                setAcademicError("Unable to load Academic Council data.");
            } finally {
                setAcademicLoading(false);
            }
        };

        fetchMembers();
    }, []);

    // Academic Council sections
    const academicSections = Object.entries(
        academicMembers.reduce((grouped, member) => {
            if (!member.section) return grouped;

            if (!grouped[member.section]) {
                grouped[member.section] = [];
            }

            grouped[member.section].push(member);
            return grouped;
        }, {})
    );
    // acedmic council start end
    // Executive council start code
    // Executive Council API
    useEffect(() => {
        const fetchExecutiveCouncil = async () => {
            try {
                const response = await fetch(
                    `${API_BASE_URL}/executive-council`
                );

                if (!response.ok) {
                    throw new Error("Failed to fetch Executive Council data.");
                }

                const result = await response.json();

                setExecutiveMembers(
                    result.success && Array.isArray(result.data)
                        ? result.data
                        : []
                );
            } catch (err) {
                console.error("Executive Council API Error:", err);
                setExecutiveError("Unable to load Executive Council data.");
            } finally {
                setExecutiveLoading(false);
            }
        };

        fetchExecutiveCouncil();
    }, []);

    // Executive Council sections
    const executiveSections = Object.entries(
        executiveMembers.reduce((grouped, member) => {
            if (!member.member_section) return grouped;

            if (!grouped[member.member_section]) {
                grouped[member.member_section] = [];
            }

            grouped[member.member_section].push(member);
            return grouped;
        }, {})
    );

//  const API_BASE_URL =
//   window.location.hostname === "localhost" ||
//   window.location.hostname === "127.0.0.1"
//     ? "http://127.0.0.1:8000/api"
//     : "https://api.kunainital.ac.in/api";

console.log('API_BASE_URL', API_BASE_URL)

const COLLEGES_API = `${API_BASE_URL}/affiliated-colleges-list`;

// Put the real PDF paths here (public folder or API storage URL)
const PDF_LINKS = [
  { label: "Affiliated Colleges (Govt.).pdf", href: "/docs/Affiliated_Colleges_(Govt.).pdf" },
  { label: "Affiliated Colleges (Private).pdf", href: "/docs/Affiliated_Colleges_(Private).pdf" },
];

// Normalises govt_pvt values coming from the DB into a fixed key
const getTypeKey = (value) => {
  const v = String(value || "").trim().toLowerCase();
  if (v.startsWith("g")) return "government";
  if (v.startsWith("p")) return "private";
  if (v.startsWith("a")) return "aided";
  return "other";
};

const TYPE_LABEL = {
  government: "Government",
  private: "Private",
  aided: "Aided",
  other: "Other",
};

const TYPE_BADGE = {
  government: "bg-emerald-100 text-emerald-800 border-emerald-200",
  private: "bg-indigo-100 text-indigo-800 border-indigo-200",
  aided: "bg-amber-100 text-amber-800 border-amber-200",
  other: "bg-gray-100 text-gray-700 border-gray-200",
};


      const [colleges, setColleges] = useState([]);
      const [loading, setLoading] = useState(true);
      const [error, setError] = useState("");
      const [activeFilter, setActiveFilter] = useState("all");
      const [search, setSearch] = useState("");
    
      useEffect(() => {
        const controller = new AbortController();
    
        const fetchColleges = async () => {
          try {
            setLoading(true);
            setError("");
    
            const response = await fetch(COLLEGES_API, {
              signal: controller.signal,
              headers: { Accept: "application/json" },
            });
    
            if (!response.ok) throw new Error(`Request failed (${response.status})`);
    
            const result = await response.json();
    
            if (!result.success) {
              throw new Error(result.message || "Unable to load colleges.");
            }
    
            setColleges(Array.isArray(result.data) ? result.data : []);
          } catch (err) {
            if (err.name !== "AbortError") {
              setError(err.message || "Something went wrong while loading colleges.");
            }
          } finally {
            if (!controller.signal.aborted) setLoading(false);
          }
        };
    
        fetchColleges();
        return () => controller.abort();
      }, []);
    
      // Counts for the filter pills
      const counts = useMemo(() => {
        const c = { all: colleges.length, government: 0, private: 0, aided: 0 };
        colleges.forEach((college) => {
          const key = getTypeKey(college.govt_pvt);
          if (c[key] !== undefined) c[key] += 1;
        });
        return c;
      }, [colleges]);
    
      const filteredColleges = useMemo(() => {
        const q = search.trim().toLowerCase();
    
        return colleges.filter((college) => {
          const matchesType =
            activeFilter === "all" || getTypeKey(college.govt_pvt) === activeFilter;
    
          const matchesSearch =
            !q ||
            String(college.coll_cd ?? "").toLowerCase().includes(q) ||
            String(college.coll_name ?? "").toLowerCase().includes(q) ||
            String(college.dist_name ?? "").toLowerCase().includes(q);
    
          return matchesType && matchesSearch;
        });
      }, [colleges, activeFilter, search]);
    
      const filters = [
        { key: "all", label: "All" },
        { key: "government", label: "Government" },
        { key: "private", label: "Private" },
        { key: "aided", label: "Aided" },
      ];


    // Executive council start end
    switch (slug) {
        case "university-at-a-glance":
            return (
                <div className="min-h-screen bg-[var(--paper)]">
                    <Header />

                    {/* HERO */}
                    <section className="relative h-[420px] overflow-hidden">
                        <img src="/images/campusKumaun.avif" alt="Kumaun University"
                            className="absolute inset-0 w-full h-full object-cover" />

                        {/* Overlay */}
                        <div className="absolute inset-0 bg-gradient-to-r from-[#d1fae5]/95 via-[#a7f3d0]/80 to-[#ecfdf5]/40" />
                        <div className="relative z-10 max-w-7xl mx-auto h-full px-6 flex items-center">
                            <div className="max-w-3xl text-white">

                                {/* Breadcrumb */}
                                <div className="flex items-center gap-2 text-sm text-white/70 mb-5">
                                    {/* <span>Home</span> */}
                                    {/* <span>/</span> */}
                                    <span className="text-[#123B5D] text-lg font-gill font-gill">
                                        About
                                    </span>

                                    <span className="text-[#123B5D] text-lg font-gill">
                                        /
                                    </span>

                                    <span className="text-[#123B5D] text-lg font-gill font-gill">
                                        University at a Glance
                                    </span>
                                </div>

                                {/* <p className="uppercase tracking-[0.25em] text-sm text-[var(--saffron)] font-gill mb-4">
                    Kumaun University
                </p> */}

                                <h1 className="text-4xl md:text-6xl font-bold leading-tight text-[#064E3B] font-gill">
                                    University at a Glance
                                </h1>

                                <p className="mt-5 text-lg text-[#123B5D] max-w-2xl text-justify font-gill">
                                    Discover the history, vision, campuses and academic
                                    excellence of Kumaun University.
                                </p>
                            </div>
                        </div>
                    </section>

                    {/* STATS */}
                    <section className="relative z-20 -mt-12 px-6">
                        <div className="max-w-6xl mx-auto">
                            <div
                                className="bg-white rounded-2xl shadow-xl border border-gray-100 
                       grid grid-cols-1 sm:grid-cols-3 overflow-hidden">

                                <Stat icon={<CalendarDays size={33} />}
                                    value="1973"
                                    label="Year of Establishment"
                                />

                                <Stat icon={<MapPin size={33} />}
                                    value="160 acres"
                                    label="Our Campuses Area"
                                />

                                <Stat icon={<Building2 size={33} />}
                                    value="300+"
                                    label="Faculty Members"
                                />

                            </div>
                        </div>
                    </section>

                    {/* ABOUT CONTENT */}
                    <section className="max-w-7xl mx-auto px-6 py-20">
                        <div className="grid lg:grid-cols-2 gap-14 items-center">

                            {/* IMAGE */}
                            <div className="relative">
                                <div className="absolute -left-5 -bottom-5 w-full h-full rounded-3xl bg-[var(--saffron)]/20" />

                                <img src="/images/university_glance.jpeg" alt="Kumaun University Campus"
                                    className="relative w-full h-[430px] object-cover rounded-3xl shadow-xl" />
                            </div>

                            {/* CONTENT */}
                            <div>
                                <p className="uppercase tracking-[0.2em] text-sm font-bold text-[var(--terracotta)] mb-3 font-gill">
                                    About the University
                                </p>

                                <h2 className="text-3xl md:text-4xl font-bold text-[var(--ink)] mb-6 font-gill">
                                    UNIVERSITY AT A GLANCE
                                </h2>

                                <p className="text-gray-600 leading-8 mb-5 text-justify font-gill text-lg">
                                    Established in 1973, Kumaun University, nestled in Uttarakhand, emerged from the merger of two
                                    eminent government colleges, namely, D.S.B. Government P.G. College, Nainital and Almora Government
                                    P.G. College. Kumaun University earned its recognition from the University Grants Commission (UGC)
                                    in New Delhi under Section 12-B of the UGC Act, 1956. This recognition enabled the University to
                                    receive consistent support from the UGC. Over time, the University transformed from a mere
                                    institution to a leading academic beacon for thousands in the Kumaun Region of Uttarakhand.
                                </p>

                                {/* <p className="text-gray-600 leading-8 mb-7 text-justify">
                    Recognizing the diverse educational needs of Kumaun's remote areas, the State Legislature
                    implemented the SSJ University Act (Act No. 20 of 2019). This decision led to the bifurcation of
                    Kumaun University and the establishment of SSJ University Almora. This pivotal change was officially
                    announced by the Uttarakhand Government on 22nd June 2020 through Order No. 168/XXXVI (3) 2020/ 771/
                    2019.
                </p> */}

                                {/* <button
                    className="
                    inline-flex
                    items-center
                    gap-2
                    px-6
                    py-3
                    rounded-full
                    bg-[var(--terracotta)]
                    text-white
                    font-gill
                    hover:opacity-90
                    transition
                  ">
                    Explore University
                    <ArrowRight size={18} />
                </button> */}
                            </div>

                        </div>
                    </section>
                    <section className="bg-white py-12">
                        <div className="max-w-7xl mx-auto px-6">



                            <div className="space-y-5 text-[16px] leading-7 text-gray-700 text-justify">

                                <p className="text-justify font-gill text-lg">
                                    Recognizing the diverse educational needs of Kumaun's remote areas, the State Legislature
                                    implemented the SSJ University Act (Act No. 20 of 2019). This decision led to the bifurcation of
                                    Kumaun University and the establishment of SSJ University Almora. This pivotal change was officially
                                    announced by the Uttarakhand Government on 22nd June 2020 through Order No. 168/XXXVI (3) 2020/ 771/
                                    2019.
                                </p>

                                <p className="text-justify font-gill text-lg">
                                    Now, the Kumaun University's sprawling campuses at D.S.B., Nainital and Sir J C Bose at Bhimtal
                                    cover an area of approximately 160 acres, featuring state-of-the-art facilities. With affiliations
                                    to 20 government colleges, 61 private institutions, and a government-aided college, the university
                                    supports around 1,50,000 students, making it Uttarakhand's largest.
                                </p>

                                <p className="text-justify font-gill text-lg">
                                    A key feature that sets Kumaun University apart is its unwavering commitment to delivering an
                                    inclusive educational environment, irrespective of background, race, or faith. The institution
                                    diligently fosters a spirit of innovation, civic responsibility, and personal integrity. Its
                                    endeavors to bridge the gap between academia, government, and industry are commendable.
                                </p>

                                <p className="text-justify font-gill text-lg"> Over the past three years, the university has focused on
                                    establishing recognized departments for both scientific and social research. This initiative has
                                    garnered attention from faculty members and students countrywide. Pre-Uttarakhand state formation,
                                    Kumaun University set benchmarks for state universities in terms of academic rigor, student
                                    discipline, resource generation, and maintaining a conducive learning environment. Such standards
                                    earned the university an 'A' Grade accreditation from the National Assessment and Accreditation
                                    Council (NAAC) in 2015.</p>
                                <p className="text-justify font-gill text-lg">Offering a rich tapestry of courses, Kumaun University
                                    boasts eight faculties encompassing diverse fields from Arts, Sciences, Commerce, Management,
                                    Education, Law, Technology, to Visual Arts. Furthermore, the university pioneers several
                                    self-finance courses, ensuring flexibility and inclusivity. </p>
                                <p className="text-justify font-gill text-lg">Internationally, the University doesn't lag. It embarked
                                    on a prestigious project, "Landscape Asia," in collaboration with the University of Paris,
                                    spotlighting transformation processes in five Asian countries. Collaborative research ventures also
                                    extend to the Massachusetts Institute of Technology, USA, and Trinity College, Dublin, Ireland. The
                                    establishment of the Centre for Nanoscience and Nanotechnology in partnership with global
                                    institutions underlines Kumaun University's vision to lead in cutting-edge research. </p>
                                <p className="text-justify font-gill text-lg">An essential facet of the university's operations is its
                                    Resource Development Centre. Established in 2007, this first-of-its-kind centre in Uttarakhand aims
                                    at teacher training and innovative extension in higher education. Upholding UGC's guidelines, the
                                    university constituted the Internal Quality Assurance Cell in 2009, emphasizing quality in teaching,
                                    research, and administrative activities. </p>
                                <p className="text-justify font-gill text-lg">For the empowerment and development of women, the
                                    university's dedicated centre functions diligently, resonating with national goals. Leveraging
                                    modern technology, Kumaun University's Digital Initiative Cell continually updates information
                                    related to academic and administrative functions, providing a streamlined experience for
                                    stakeholders. </p>
                                <p className="text-justify font-gill text-lg">The National Cadet Corps and NSS Units of the university
                                    play pivotal roles in student development. Their activities span from environmental upgradation,
                                    societal awareness campaigns, discipline drives, to various other initiatives. Honouring literary
                                    greats, the university has dedicated the “Mahadevi Verma Peeth” for research in language and
                                    literature, generously funded by the Government of Uttarakhand. </p>
                                <p className="text-justify font-gill text-lg">In the realm of law, the Dr. Rajendra Prasad Law Institute
                                    houses the “Free Legal Aid and Counselling Centre,” ensuring legal aid is accessible to all. Another
                                    commendable endeavour is the establishment of a Community College under the aegis of the UGC. </p>
                                <p className="text-justify font-gill text-lg"> Kumaun University's alumni are a testament to its
                                    excellence. With achievers spanning various fields, from Padma Award winners, Scientists, Writers,
                                    to Bureaucrats, the University has significantly impacted diverse sectors.</p>
                                <p className="text-justify font-gill text-lg">Kumaun University, deeply anchored in values of trust,
                                    safety, and respect, is on a trajectory to distinguish itself as a global frontrunner in education
                                    with a special emphasis on job readiness. Aiming for an all-encompassing student experience, the
                                    University seeks to build cross-sectoral collaborations. Recent recognitions, such as its 30th
                                    placement in The India Today Group Survey (2023), 61st position in NIRF (Pharmacy Category), along
                                    with noteworthy ranks of 551-600 globally and 145 nationally in the QS BRICS Countries Survey
                                    (2022), speak volumes about its academic prowess. Additionally, the University's UGC HRDC has made
                                    its mark, clinching the 4th rank nationally in the 2022 NAAC evaluation by UGC.</p>
                                <p className="text-justify font-gill text-lg">In sum, Kumaun University, steeped in its illustrious
                                    past, offers a wide spectrum of courses and, with a clear vision, stands as a paragon of educational
                                    excellence globally. </p>


                            </div>
                        </div>
                    </section>
                    {/* HIGHLIGHTS */}
                    {/* <section className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-6">

            <div className="text-center max-w-2xl mx-auto mb-12">
                <p className="uppercase tracking-[0.2em] text-sm font-bold text-[var(--terracotta)]">
                    University Highlights
                </p>

                <h2 className="text-3xl md:text-4xl font-bold text-[var(--ink)] mt-3">
                    At a Glance
                </h2>
            </div>

            <div className="grid md:grid-cols-3 gap-6">

                <Highlight title="Academic Excellence"
                    text="A wide range of undergraduate, postgraduate and doctoral programmes." />

                <Highlight title="Research & Innovation"
                    text="Promoting research, innovation and knowledge creation across disciplines." />

                <Highlight title="Himalayan Campus"
                    text="A unique learning environment surrounded by the natural beauty of the Himalayas." />

            </div>
        </div>
    </section> */}

                    <Footer />

                </div>

            );

        case "vice-chancellors-message":
            return (
                <div className="min-h-screen bg-[var(--paper)]">
                    <Header />
                    {/* HERO */}
                    <section className="relative h-[250px] overflow-hidden">
                        <img src="/images/campusKumaun.avif" alt="Kumaun University"
                            className="absolute inset-0 w-full h-full object-cover" />

                        {/* Overlay */}
                        <div className="absolute inset-0 bg-gradient-to-r from-[#d1fae5]/95 via-[#a7f3d0]/80 to-[#ecfdf5]/40" />
                        <div className="relative z-10 max-w-7xl mx-auto h-full px-6 flex items-center">
                            <div className="max-w-3xl text-white">

                                {/* Breadcrumb */}
                                <div className="flex items-center gap-2 text-sm text-white/70 mb-5">
                                    {/* <span>Home</span> */}
                                    {/* <span>/</span> */}
                                    <span className="text-[#123B5D] text-lg font-gill font-gill">
                                        About
                                    </span>

                                    <span className="text-[#123B5D] text-lg font-gill">
                                        /
                                    </span>

                                    <span className="text-[#123B5D] text-lg font-gill font-gill">
                                        VICE CHANCELLOR'S MESSAGE
                                    </span>
                                </div>

                                {/* <p className="uppercase tracking-[0.25em] text-sm text-[var(--saffron)] font-gill mb-4">
                    Kumaun University
                </p> */}

                                <h1 className="text-4xl md:text-4xl font-bold leading-tight text-[#064E3B] font-gill">
                                    VICE CHANCELLOR'S MESSAGE
                                </h1>

                                {/* <p className="mt-5 text-lg text-[#123B5D] max-w-2xl">
                    Discover the history, vision, campuses and academic
                    excellence of Kumaun University.
                </p> */}
                            </div>
                        </div>
                    </section>



                    

                    {/* HIGHLIGHTS */}
                    <section className="bg-white py-12">
                        <div className="max-w-7xl mx-auto px-6">

                            <h2 className="text-3xl md:text-4xl font-bold text-[#08245c] mb-3 font-gill">
                                Vice Chancellor's Message
                            </h2>

                            <p className="font-bold text-gray-700 mb-5 font-gill">
                                Dear Students, Faculty Members, and Esteemed Visitors,
                            </p>

                            <div className="space-y-5 text-[16px] leading-7 text-gray-700 text-justify">

                                <p className="text-justify font-gill text-lg">
                                    It gives me immense pleasure to welcome you to Kumaun University, an institution with a rich
                                    academic heritage and a strong commitment to academic excellence, research, innovation, and holistic
                                    student development.
                                </p>

                                <p className="text-justify font-gill text-lg">
                                    A university is not merely a place for acquiring degrees, but a centre for developing knowledge,
                                    critical thinking, creativity, character, and a sense of responsibility towards society. Our
                                    endeavour is to provide a supportive and inclusive academic environment where students can explore
                                    their potential and prepare themselves for the challenges of the future.
                                </p>

                                <p className="text-justify font-gill text-lg">
                                    We remain committed to strengthening teaching and learning, promoting quality research and
                                    innovation, encouraging academic collaboration, and embracing modern technology while preserving our
                                    rich cultural and intellectual heritage.
                                </p>

                                <p className="text-justify font-gill text-lg">
                                    I encourage our students to approach their academic journey with curiosity, dedication, discipline,
                                    and confidence. Make the most of every opportunity and strive to contribute positively to society.
                                </p>
                                <p className="text-justify font-gill text-lg">
                                    Together, through the collective efforts of our students, faculty, researchers, alumni, and staff,
                                    we can carry forward the proud legacy of Kumaun University and take it to new heights.
                                </p>
                                <h1 className="font-bold text-[#08245c] mb-3 font-gill">
                                    I warmly welcome you to Kumaun University and wish you a successful and enriching academic journey.
                                </h1>
                                <h4 className="font-bold text-[#08245c] mb-3 font-gill">
                                    With best wishes,
                                </h4>

                            </div>
                            {/* vice name */}
                            <div className="flex items-center justify-end gap-4 py-4">
                                {/* Icon */}
                                <div
                                    className="flex h-12 w-12 items-center justify-center rounded-full bg-red-50 border border-red-200">
                                    <UserRound className="w-6 h-6 text-red-600" />
                                </div>

                                {/* Divider */}
                                <div className="h-12 w-[2px] bg-red-600"></div>

                                {/* VC Details */}
                                <div className="text-right">
                                    <h3 className="text-[21px] font-bold text-[#12326b] font-gill">
                                        Prof. Satpal Singh Bisht
                                    </h3>

                                    <p className="mt-1 text-[15px] font-medium text-gray-700 font-gill">
                                        Vice Chancellor
                                        <span className="mx-2 text-red-500 font-gill">|</span>
                                        Kumaun University
                                    </p>

                                    <a href="mailto:vc@kunainital.ac.in"
                                        className="mt-1 inline-flex items-center gap-1.5 text-[14px] text-gray-600 hover:text-red-600">
                                        <Mail className="w-4 h-4" />
                                        vc@kunainital.ac.in
                                    </a>
                                </div>
                            </div>
                            {/* vice name */}

                        </div>
                    </section>
                    <Footer />

                </div>
            );
case "vice-chancellor-profile":
            return (
                <div className="min-h-screen bg-[var(--paper)]">
                    <Header />
                    {/* HERO */}
                    <section className="relative h-[250px] overflow-hidden">
                        <img src="/images/campusKumaun.avif" alt="Kumaun University"
                            className="absolute inset-0 w-full h-full object-cover" />

                        {/* Overlay */}
                        <div className="absolute inset-0 bg-gradient-to-r from-[#d1fae5]/95 via-[#a7f3d0]/80 to-[#ecfdf5]/40" />
                        <div className="relative z-10 max-w-7xl mx-auto h-full px-6 flex items-center">
                            <div className="max-w-3xl text-white">

                                {/* Breadcrumb */}
                                <div className="flex items-center gap-2 text-sm text-white/70 mb-5">
                                    {/* <span>Home</span> */}
                                    {/* <span>/</span> */}
                                    <span className="text-[#123B5D] text-lg font-gill font-gill">
                                        About
                                    </span>

                                    <span className="text-[#123B5D] text-lg font-gill">
                                        /
                                    </span>

                                    <span className="text-[#123B5D] text-lg font-gill font-gill">
                                        VICE CHANCELLOR'S PROFILE
                                    </span>
                                </div>

                                {/* <p className="uppercase tracking-[0.25em] text-sm text-[var(--saffron)] font-gill mb-4">
                    Kumaun University
                </p> */}

                                <h1 className="text-4xl md:text-4xl font-bold leading-tight text-[#064E3B] font-gill">
                                    VICE CHANCELLOR'S PROFILE
                                </h1>

                                {/* <p className="mt-5 text-lg text-[#123B5D] max-w-2xl">
                    Discover the history, vision, campuses and academic
                    excellence of Kumaun University.
                </p> */}
                            </div>
                        </div>
                    </section>



                    {/* ABOUT CONTENT */}
                    <section className="max-w-7xl mx-auto px-6 py-20">
                        <div className="grid lg:grid-cols-2 gap-14 items-center">

                            {/* IMAGE */}
                            <div className="relative max-w-md mx-auto">
                                <div className="relative overflow-hidden rounded-[28px] shadow-xl bg-white">

                                    {/* Image */}
                                    <div className="aspect-[4/5] w-full overflow-hidden">
                                        <img src="/images/Satya_pal_vc.jpeg" alt="Prof. Satpal Singh Bisht"
                                            className="w-full h-full object-cover object-center" />
                                    </div>

                                    {/* Name */}
                                    <div className="bg-[#ef4949] text-white text-center px-4 py-3">
                                        <h3 className="text-xl md:text-2xl font-bold font-serif font-gill">
                                            Prof. Satpal Singh Bisht
                                        </h3>

                                        <p className="mt-1 text-sm md:text-base font-medium font-gill">
                                            Hon’ble Vice Chancellor
                                        </p>
                                    </div>

                            
                                </div>
                               
                            </div>

                            {/* CONTENT */}
                            <div>
                                {/* <p className="uppercase tracking-[0.2em] text-sm font-bold text-[var(--terracotta)] mb-3">
                    About the University
                </p> */}

                                <h2 className="text-3xl md:text-4xl font-bold font-gill text-[var(--terracotta)] mb-6">
                                    About Vice Chancellor's
                                </h2>

                                <p className="text-gray-600 text-xl font-gill leading-8 mb-5 text-justify">
                                    Prof. Satpal Singh Bisht is an eminent academician and researcher with over three decades of
                                    experience in higher education, teaching, and research. He has served in various academic and
                                    administrative positions, including Vice-Chancellor of Soban Singh Jeena University, Almora, and has
                                    held several important responsibilities at Kumaun University. His academic contributions include
                                    extensive research in the field of biosciences and supervision of doctoral research. He has now
                                    assumed charge as the Vice-Chancellor of Kumaun University, Nainital.
                                </p>

                                {/* <p className="text-gray-600 leading-8 mb-7 text-justify">
                    With its beautiful Himalayan surroundings, the
                    University provides an inspiring environment for
                    teaching, learning, research and innovation.
                </p> */}

                                {/* <button
                    className="
                    inline-flex
                    items-center
                    gap-2
                    px-6
                    py-3
                    rounded-full
                    bg-[var(--terracotta)]
                    text-white
                    font-gill
                    hover:opacity-90
                    transition
                  ">
                    Explore University
                    <ArrowRight size={18} />
                </button> */}
                    <div className="flex flex-col items-start gap-3">
                        <div className="flex items-center gap-2">
                            <UserRound className="w-5 h-5 text-red-600 fill-red-600" />

                            <span className="text-[15px] text-gray-700 font-gill">
                                Hon’ble Vice Chancellor
                            </span>
                        </div>

                        <button
                            onClick={() => navigate("/about/vice-chancellors-message")}
                            className="bg-blue-600 text-white px-5 py-2 rounded hover:bg-blue-700"
                        >
                            Message
                        </button>
                    </div>
                            </div>
                           

                        </div>
                    </section>

                    
                    <Footer />

                </div>
            );

        case "the-court":
            return (
                <div className="min-h-screen bg-[var(--paper)]">
                    <Header />
                    {/* HERO */}
                    <section className="relative h-[250px] overflow-hidden">
                        <img src="/images/campusKumaun.avif" alt="Kumaun University"
                            className="absolute inset-0 w-full h-full object-cover" />

                        {/* Overlay */}
                        <div className="absolute inset-0 bg-gradient-to-r from-[#d1fae5]/95 via-[#a7f3d0]/80 to-[#ecfdf5]/40" />
                        <div className="relative z-10 max-w-7xl mx-auto h-full px-6 flex items-center">
                            <div className="max-w-3xl text-white">

                                {/* Breadcrumb */}
                                <div className="flex items-center gap-2 text-sm text-white/70 mb-5">
                                    {/* <span>Home</span> */}
                                    {/* <span>/</span> */}
                                    <span className="text-[#123B5D] text-lg font-gill font-gill">
                                        About
                                    </span>

                                    <span className="text-[#123B5D] text-lg font-gill">
                                        /
                                    </span>

                                    <span className="text-[#123B5D] text-lg font-gill ">
                                        The Court
                                    </span>
                                </div>

                                {/* <p className="uppercase tracking-[0.25em] text-sm text-[var(--saffron)] font-gill mb-4">
                    Kumaun University
                </p> */}

                                <h1 className="text-4xl md:text-4xl font-bold leading-tight text-[#064E3B] font-gill">
                                    THE COURT - KUMAUN UNIVERSITY, NAINITAL
                                </h1>

                                {/* <p className="mt-5 text-lg text-[#123B5D] max-w-2xl">
                    Discover the history, vision, campuses and academic
                    excellence of Kumaun University.
                </p> */}
                            </div>
                        </div>
                    </section>

                    {/* STATS */}


                    {/* ABOUT CONTENT */}
                    <section className="py-16 bg-[#f8faf9]">
                        <div className="max-w-6xl mx-auto px-4">

                            {/* Main Heading */}
                            <div className="text-center mb-12">
                                {/* <span
                    className="inline-block px-4 py-1.5 rounded-full bg-[#e7f3ed] text-[#176b4d] text-sm font-gill mb-4">
                    UNIVERSITY COURT
                </span> */}

                                <h2 className="text-3xl md:text-4xl font-bold text-[#123c5a] font-gill">
                                    The Court shall consist of the following members, namely—
                                </h2>

                                <div className="w-20 h-1 bg-[#d6a84f] mx-auto mt-4 rounded-full"></div>
                            </div>


                            {/* Class I */}
                            <div className="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-7">

                                <div className="flex items-center gap-4 bg-gradient-to-r from-[#123c5a] to-[#1c607d] px-2 py-2">
                                    <div
                                        className="w-12 h-12 rounded-full bg-white/15 flex items-center justify-center text-white font-bold text-lg">
                                        I
                                    </div>

                                    <div>
                                        <h3 className="text-xl md:text-2xl font-bold text-white font-gill">
                                            Ex-officio Members
                                        </h3>
                                        <p className="text-white/70 text-sm">
                                            Class I
                                        </p>
                                    </div>
                                </div>

                                <div className="p-2 md:p-2">
                                    <div className="grid md:grid-cols-3 gap-4">

                                        {[
                                            "The Chancellor.",
                                            "The members of the Executive Council.",
                                            "The Finance Officer."
                                        ].map((item, index) => (
                                            <div key={index}
                                                className="flex items-start gap-3 p-4 rounded-xl bg-[#f7faf9] border border-gray-100 hover:shadow-sm transition">
                                                <span
                                                    className="flex-shrink-0 w-7 h-7 rounded-full bg-[#d6a84f] text-white flex items-center justify-center text-sm font-bold">
                                                    {index + 1}
                                                </span>

                                                <p className="text-gray-700 leading-relaxed">
                                                    {item}
                                                </p>
                                            </div>
                                        ))}

                                    </div>
                                </div>
                            </div>


                            {/* Class II */}
                            <div className="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-7">

                                <div className="flex items-center gap-4 bg-gradient-to-r from-[#176b4d] to-[#27845f] px-2 py-2">
                                    <div
                                        className="w-12 h-12 rounded-full bg-white/15 flex items-center justify-center text-white font-bold text-lg">
                                        II
                                    </div>

                                    <div>
                                        <h3 className="text-xl md:text-2xl font-bold text-white font-gill">
                                            Life Members
                                        </h3>
                                        <p className="text-white/70 text-sm font-gill">
                                            Class II
                                        </p>
                                    </div>
                                </div>

                                <div className="p-2 md:p-2">
                                    <p className="text-gray-700 leading-8 text-justify font-gill">
                                        In the case of an existing University, every person who was a
                                        life member of the Court or Senate immediately before the
                                        commencement of this Act.
                                    </p>
                                </div>
                            </div>


                            {/* Class III */}
                            <div className="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-7">

                                <div className="flex items-center gap-4 bg-gradient-to-r from-[#123c5a] to-[#1c607d] px-2 py-2">
                                    <div
                                        className="w-12 h-12 rounded-full bg-white/15 flex items-center justify-center text-white font-bold text-lg">
                                        III
                                    </div>

                                    <div>
                                        <h3 className="text-xl md:text-2xl font-bold text-white font-gill">
                                            Representatives of Teachers, etc.
                                        </h3>
                                        <p className="text-white/70 text-sm font-gill">
                                            Class III
                                        </p>
                                    </div>
                                </div>

                                <div className="p-2 md:p-2">

                                    <div className="space-y-4 text-justify font-gill">

                                        {[
                                            "All heads of departments of the University and of constituent colleges maintained by it.",
                                            "The Deans of Faculties of Medicine and Engineering, if they are not members of the Executive Council.",
                                            "Two representatives of provosts and wardens of hostels and halls of the University and of its constituent colleges and Institutes to be selected by rotation in the manner prescribed.",
                                            "All Principals of constituent colleges maintained by the State Government.",
                                            "Fifteen teachers to be selected in the manner prescribed.",
                                            "Two representatives of the managements of the affiliated or associated colleges to be selected by rotation in the manner prescribed."
                                        ].map((item, index) => (
                                            <div key={index}
                                                className="group flex items-start gap-4 p-4 rounded-xl bg-[#f8faf9] border border-gray-100 hover:border-[#d6a84f] hover:bg-[#fffdf7] transition-all duration-300">

                                                <div
                                                    className="flex-shrink-0 w-8 h-8 rounded-lg bg-[#176b4d] text-white flex items-center justify-center font-gill group-hover:bg-[#d6a84f] transition">
                                                    {index + 1}
                                                </div>

                                                <p className="text-gray-700 leading-7 pt-0.5">
                                                    {item}
                                                </p>

                                            </div>
                                        ))}

                                    </div>
                                </div>
                            </div>


                            {/* Class IV */}
                            <div className="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-7">

                                <div className="flex items-center gap-4 bg-gradient-to-r from-[#176b4d] to-[#27845f] px-2 py-2">
                                    <div
                                        className="w-12 h-12 rounded-full bg-white/15 flex items-center justify-center text-white font-bold text-lg">
                                        IV
                                    </div>

                                    <div>
                                        <h3 className="text-xl md:text-2xl font-bold text-white font-gill">
                                            Registered Graduates
                                        </h3>
                                        <p className="text-white/70 text-sm">
                                            Class IV
                                        </p>
                                    </div>
                                </div>

                                <div className="p-2 md:p-2">

                                    <div className="flex items-start gap-4 p-5 rounded-xl bg-[#f8faf9] border border-gray-100">

                                        <div
                                            className="flex-shrink-0 w-10 h-10 rounded-full bg-[#d6a84f] text-white flex items-center justify-center font-bold">
                                            IV
                                        </div>

                                        <p className="text-gray-700 leading-8 text-justify font-gill">
                                            Fifteen representatives of registered graduates to be elected,
                                            by registered graduates of such standing as may be prescribed
                                            from amongst such of them as are not in the service of the
                                            University or of an Institute or of a constituent college or
                                            in the service or connected with the management of affiliated
                                            college, associated college, hall or hostel.
                                        </p>

                                    </div>

                                </div>
                            </div>

                            {/* Class V */}
                            <div className="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-7">

                                <div className="flex items-center gap-4 bg-gradient-to-r from-[#123c5a] to-[#1c607d] px-2 py-2">
                                    <div
                                        className="w-12 h-12 rounded-full bg-white/15 flex items-center justify-center text-white font-bold text-lg">
                                        V
                                    </div>

                                    <div>
                                        <h3 className="text-xl md:text-2xl font-bold text-white font-gill">
                                            Representation of Students
                                        </h3>
                                        <p className="text-white/70 text-sm">
                                            Class V
                                        </p>
                                    </div>
                                </div>

                                <div className="p-2 md:p-2">

                                    <div className="flex items-start gap-4 p-5 rounded-xl bg-[#f8faf9] border border-gray-100">

                                        {/* <div
                            className="flex-shrink-0 w-10 h-10 rounded-full bg-[#d6a84f] text-white flex items-center justify-center font-bold">
                            IV
                        </div> */}

                                        <p className="text-gray-700 leading-8 text-justify font-gill">
                                            One student from each of the faculties, who having secured the highest marks in that Faculty
                                            at the preceding degree examination of any University is pursuing a course of study for a
                                            postgraduate degree or a law or a medical or engineering degree in the University (including
                                            an affiliated or associated college)
                                        </p>

                                    </div>

                                </div>
                            </div>
                            {/* Class VI */}
                            <div className="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-7">

                                <div className="flex items-center gap-4 bg-gradient-to-r from-[#176b4d] to-[#27845f] px-2 py-2">
                                    <div
                                        className="w-12 h-12 rounded-full bg-white/15 flex items-center justify-center text-white font-bold text-lg">
                                        VI
                                    </div>

                                    <div>
                                        <h3 className="text-xl md:text-2xl font-bold text-white font-gill">
                                            Nominees of Chancellor
                                        </h3>
                                        {/* <p className="text-white/70 text-sm">
                            Class IV
                        </p> */}
                                    </div>
                                </div>


                            </div>
                            {/* Class VII */}
                            <div className="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-7">

                                <div className="flex items-center gap-4 bg-gradient-to-r from-[#123c5a] to-[#1c607d] px-2 py-2">
                                    <div
                                        className="w-12 h-12 rounded-full bg-white/15 flex items-center justify-center text-white font-bold text-lg">
                                        VII
                                    </div>

                                    <div>
                                        <h3 className="text-xl md:text-2xl font-bold text-white font-gill">
                                            Representatives of the State Legislature
                                        </h3>
                                        <p className="text-white/70 text-sm">
                                            Class VII
                                        </p>
                                    </div>
                                </div>

                                <div className="p-2 md:p-2">

                                    <div className="space-y-4 font-gill">

                                        {[
                                            "Two members of the Legislative Council to be elected by it.",

                                            "Five members of the Legislative Assembly to be elected by it.",


                                        ].map((item, index) => (
                                            <div key={index}
                                                className="group flex items-start gap-4 p-4 rounded-xl bg-[#f8faf9] border border-gray-100 hover:border-[#d6a84f] hover:bg-[#fffdf7] transition-all duration-300">

                                                <div
                                                    className="flex-shrink-0 w-8 h-8 rounded-lg bg-[#176b4d] text-white flex items-center justify-center font-gill group-hover:bg-[#d6a84f] transition">
                                                    {index + 1}
                                                </div>

                                                <p className="text-gray-700 leading-7 pt-0.5">
                                                    {item}
                                                </p>

                                            </div>
                                        ))}

                                    </div>
                                </div>
                            </div>
                            {/* NOTE */}
                            <div className="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-7">

                                <div className="flex items-center gap-4 bg-gradient-to-r from-[#f81919] to-[#f73030] px-2 py-2">
                                    {/* <div
                        className="w-12 h-12 rounded-full bg-white/15 flex items-center justify-center text-white font-bold text-lg">

                    </div> */}

                                    <div>
                                        <h3 className="text-xl md:text-2xl font-bold text-white font-gill">
                                            NOTE
                                        </h3>
                                        {/* <p className="text-white/70 text-sm">
                            Class V
                        </p> */}
                                    </div>
                                </div>

                                <div className="p-2 md:p-2">

                                    <div className="flex items-start gap-4 p-5 rounded-xl bg-[#f8faf9] border border-gray-100">

                                        {/* <div
                            className="flex-shrink-0 w-10 h-10 rounded-full bg-[#d6a84f] text-white flex items-center justify-center font-bold">
                            IV
                        </div> */}

                                        <p className="text-gray-700 leading-8 text-justify font-gill">
                                            The term of office of members of each class, except Classes I, II and V, mentioned in
                                            sub-section (1) shall be three years and the term of the members of the said class V shall
                                            be one year.
                                        </p>

                                    </div>

                                </div>
                            </div>
                        </div>

                    </section>

                    <Footer />

                </div>
            );

        case "academic-council":
            return (
                <div className="min-h-screen bg-[var(--paper)]">
                    <Header />
                    {/* HERO */}
                    <section className="relative h-[250px] overflow-hidden">
                        <img src="/images/campusKumaun.avif" alt="Kumaun University"
                            className="absolute inset-0 w-full h-full object-cover" />

                        {/* Overlay */}
                        <div className="absolute inset-0 bg-gradient-to-r from-[#d1fae5]/95 via-[#a7f3d0]/80 to-[#ecfdf5]/40" />
                        <div className="relative z-10 max-w-7xl mx-auto h-full px-6 flex items-center">
                            <div className="max-w-3xl text-white">

                                {/* Breadcrumb */}
                                <div className="flex items-center gap-2 text-sm text-white/70 mb-5">
                                    {/* <span>Home</span> */}
                                    {/* <span>/</span> */}
                                    <span className="text-[#123B5D] text-lg font-gill">
                                        About
                                    </span>

                                    <span className="text-[#123B5D] text-lg font-gill">
                                        /
                                    </span>

                                    <span className="text-[#123B5D] text-lg font-gill text-lg">
                                        Academic Council
                                    </span>
                                </div>

                                {/* <p className="uppercase tracking-[0.25em] text-sm text-[var(--saffron)] font-gill mb-4">
                    Kumaun University
                </p> */}

                                <h1 className="text-4xl md:text-4xl font-bold leading-tight text-[#064E3B] font-gill text-lg">
                                    Academic Council
                                </h1>

                                {/* <p className="mt-5 text-lg text-[#123B5D] max-w-2xl">
                    Discover the history, vision, campuses and academic
                    excellence of Kumaun University.
                </p> */}
                            </div>
                        </div>
                    </section>

                    {/* STATS */}


                    {/* ABOUT CONTENT */}
                    <section className="py-16 bg-[#f8faf9]">
                        <div className="max-w-6xl mx-auto px-4">

                            {/* Main Heading */}
                            <div className="text-center mb-0">
                                {/* <span
                    className="inline-block px-4 py-1.5 rounded-full bg-[#e7f3ed] text-[#176b4d] text-sm font-gill mb-4">
                    UNIVERSITY COURT
                </span> */}

                                {/* <h2 className="text-3xl md:text-4xl font-bold text-[#123c5a]">
                    The Court shall consist of the following members, namely—
                </h2> */}

                                {/* <div className="w-20 h-1 bg-[#d6a84f] mx-auto mt-4 rounded-full"></div> */}
                            </div>




                            {/* Class I */}
                            <div className="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-7">

                                <div className="flex items-center gap-4 bg-gradient-to-r from-[#123c5a] to-[#067a23] px-2 py-2">


                                    <div>
                                        <h3 className="text-xl md:text-1xl font-bold text-white text-justify font-gill text-lg">
                                            The Academic Council shall be the principal academic body of the University and subject to
                                            the provisions of this Act, the Statutes and the Ordinances —
                                        </h3>

                                    </div>
                                </div>

                                <div className="p-2 md:p-2">

                                    <div className="space-y-4 text-justify font-gill text-lg">

                                        {[
                                            "Shall have the control and general regulation of and be responsible for the maintenance of standard of instruction, education and research carried on or imparted in the University",

                                            "May advise the Executive Council on all academic matters including matters relating to examinations conducted by the University",

                                            "Shall have such powers and duties as may be conferred or imposed upon it by the Statutes",


                                        ].map((item, index) => (
                                            <div key={index}
                                                className="group flex items-start gap-4 p-4 rounded-xl bg-[#f8faf9] border border-gray-100 hover:border-[#d6a84f] hover:bg-[#fffdf7] transition-all duration-300">

                                                <div
                                                    className="flex-shrink-0 w-8 h-8 rounded-lg bg-[#176b4d] text-white flex items-center justify-center font-gill group-hover:bg-[#d6a84f] transition">
                                                    {index + 1}
                                                </div>

                                                <p className="text-gray-700 leading-7 pt-0.5">
                                                    {item}
                                                </p>

                                            </div>
                                        ))}

                                    </div>
                                </div>
                            </div>
                            {/* Class II */}
                            <div className="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-7">

                                <div className="flex items-center gap-4 bg-gradient-to-r from-[#067a23] to-[#1c607d] px-2 py-2">


                                    <div>
                                        <h3 className="text-xl md:text-1xl font-bold text-white text-justify font-gill text-lg">
                                            The Academic Council shall consist of the following members, namely —
                                        </h3>

                                    </div>
                                </div>

                                <div className="p-2 md:p-2">

                                    <div className="space-y-4 text-justify font-gill text-lg">

                                        {[
                                            "The Vice-Chancellor.",

                                            "The Deans of all Faculties, if any.",
                                            "All Heads of Departments of the University and where there is no department in a subject in the University, the seniormost teacher from affiliated colleges representing that subject on the Faculty concerned.",
                                            "All Professors of the University who are not Heads of Departments.",
                                            "The Principals of constituent colleges and the Directors of Institutes, if any.",
                                            "Two Professors, from each constituent college, if any, by rotation in order of seniority to be determined in the manner prescribed.",
                                            "Three Principals of affiliated or associated colleges to be selected by rotation in the manner prescribed.",
                                            "Fifteen teachers to be selected in the manner prescribed.",
                                            "The Dean of Students Welfare.",
                                            "The Librarian of the University.",
                                            "Five persons of academic eminence to be co-opted in the manner prescribed.",


                                        ].map((item, index) => (
                                            <div key={index}
                                                className="group flex items-start gap-4 p-4 rounded-xl bg-[#f8faf9] border border-gray-100 hover:border-[#d6a84f] hover:bg-[#fffdf7] transition-all duration-300">

                                                <div
                                                    className="flex-shrink-0 w-8 h-8 rounded-lg bg-[#176b4d] text-white flex items-center justify-center font-gill group-hover:bg-[#d6a84f] transition">
                                                    {index + 1}
                                                </div>

                                                <p className="text-gray-700 leading-7 pt-0.5">
                                                    {item}
                                                </p>

                                            </div>
                                        ))}

                                    </div>
                                </div>
                            </div>

                            {/* academic council details show mambers start */}

                            {/* Section-wise Academic Council Tables */}

                            <div className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
                                {academicLoading ? (
                                    <div className="py-6 text-center text-gray-600">
                                        Loading Academic Council...
                                    </div>
                                ) : academicError ? (
                                    <div className="py-6 text-center text-red-600">
                                        {academicError}
                                    </div>
                                ) : academicMembers.length === 0 ? null : (
                                    <>
                                        {/* Table Heading */}
                                        <div className="flex items-center justify-between gap-3 border-b border-red-200 bg-red-50 px-4 py-4 sm:px-6">
                                            <div className="flex items-start gap-3">
                                                <div className="mt-1 h-6 w-1 shrink-0 rounded-full bg-red-700" />
                                                <div>
                                                    <h2 className="text-base font-bold leading-6 text-red-900 sm:text-lg">
                                                        Academic Council
                                                    </h2>
                                                    <p className="mt-1 text-xs text-gray-500">
                                                        Academic Council — Member Details
                                                    </p>
                                                </div>
                                            </div>

                                            <span className="shrink-0 rounded-full border border-red-200 bg-white px-3 py-1 text-xs font-semibold text-red-800">
                                                {academicMembers.length} Members
                                            </span>
                                        </div>

                                        {/* Single Table for All Members */}
                                        <div className="overflow-x-auto">
                                            <table className="w-full min-w-[1000px] border-collapse text-sm">
                                                <thead>
                                                    <tr className="bg-[#17365D] text-white">
                                                        <th className="w-16 border-r border-white/20 px-4 py-3 text-center font-semibold">
                                                            S.No.
                                                        </th>
                                                        <th className="border-r border-white/20 px-4 py-3 text-left font-semibold">
                                                            Name
                                                        </th>
                                                        <th className="border-r border-white/20 px-4 py-3 text-left font-semibold">
                                                            Designation
                                                        </th>
                                                        <th className="border-r border-white/20 px-4 py-3 text-left font-semibold">
                                                            Faculty Section
                                                        </th>
                                                        <th className="border-r border-white/20 px-4 py-3 text-left font-semibold">
                                                            Department
                                                        </th>
                                                        <th className="border-r border-white/20 px-4 py-3 text-left font-semibold">
                                                            University / Campus
                                                        </th>
                                                        <th className="px-4 py-3 text-left font-semibold">
                                                            Academic Council Composition
                                                        </th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {academicMembers.map((member, index) => (
                                                        <tr
                                                            key={member.id ?? index}
                                                            className="border-b border-gray-200 last:border-b-0 even:bg-gray-50 hover:bg-red-50/70"
                                                        >
                                                            <td className="border-r border-gray-100 px-4 py-3 text-center text-gray-500">
                                                                {index + 1}
                                                            </td>

                                                            <td className="border-r border-gray-100 px-4 py-3 font-semibold text-gray-800">
                                                                {member.member_name || ""}
                                                            </td>

                                                            <td className="border-r border-gray-100 px-4 py-3 text-gray-700">
                                                                {member.designation || ""}
                                                            </td>

                                                            <td className="border-r border-gray-100 px-4 py-3 text-gray-700">
                                                                {member.faculty_section || ""}
                                                            </td>

                                                            <td className="border-r border-gray-100 px-4 py-3 text-gray-700">
                                                                {member.department || ""}
                                                            </td>

                                                            <td className="border-r border-gray-100 px-4 py-3 text-gray-700">
                                                                {member.campus || ""}
                                                            </td>

                                                            <td className="px-4 py-3 text-gray-700">
                                                                {member.composition_section || ""}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>

                                        {/* Table Footer */}
                                        <div className="border-t border-gray-100 bg-gray-50 px-4 py-2 text-right text-xs text-gray-500">
                                            Total Academic Council Members: {academicMembers.length}
                                        </div>
                                    </>
                                )}
                            </div>


                            {/* academic council details show mambers end */}
                            {/* NOTE */}
                            <div className="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-7">

                                <div
                                    className="flex items-center gap-4 bg-gradient-to-r from-[#f81919] to-[rgb(233,109,109)] px-2 py-2">
                                    {/* <div
                        className="w-12 h-12 rounded-full bg-white/15 flex items-center justify-center text-white font-bold text-lg">

                    </div> */}

                                    <div>
                                        <h3 className="text-xl md:text-1xl font-bold text-white font-gill">
                                            NOTE
                                        </h3>
                                        {/* <p className="text-white/70 text-sm">
                            Class V
                        </p> */}
                                    </div>
                                </div>

                                <div className="p-2 md:p-2">

                                    <div className="flex items-start gap-4 p-5 rounded-xl bg-[#f8faf9] border border-gray-100">

                                        {/* <div
                            className="flex-shrink-0 w-10 h-10 rounded-full bg-[#d6a84f] text-white flex items-center justify-center font-bold">
                            IV
                        </div> */}

                                        <p className="text-gray-700 leading-8 text-justify font-gill text-lg">
                                            If there is no member belonging to the Scheduled Castes or Scheduled Tribes or the other
                                            backward classes of citizen in the Academic Council constituted under this sub-section, the
                                            Vice-Chancellor may nominate two members belonging to the Scheduled Castes or Scheduled
                                            Tribes and two members belonging to other backward classes or citizen from amongst the
                                            teachers of the University by rotation in the manner prescribed.
                                        </p>

                                    </div>

                                </div>
                            </div>
                        </div>

                    </section>

                    <Footer />

                </div>
            );


        case "executive-council":
            return (
                <div className="min-h-screen bg-[var(--paper)]">
                    <Header />
                    {/* HERO */}
                    <section className="relative h-[250px] overflow-hidden">
                        <img src="/images/campusKumaun.avif" alt="Kumaun University"
                            className="absolute inset-0 w-full h-full object-cover" />

                        {/* Overlay */}
                        <div className="absolute inset-0 bg-gradient-to-r from-[#d1fae5]/95 via-[#a7f3d0]/80 to-[#ecfdf5]/40" />
                        <div className="relative z-10 max-w-7xl mx-auto h-full px-6 flex items-center">
                            <div className="max-w-3xl text-white">

                                {/* Breadcrumb */}
                                <div className="flex items-center gap-2 text-sm text-white/70 mb-5">
                                    {/* <span>Home</span> */}
                                    {/* <span>/</span> */}
                                    <span className="text-[#123B5D] text-lg font-gill">
                                        About
                                    </span>

                                    <span className="text-[#123B5D] text-lg font-gill">
                                        /
                                    </span>

                                    <span className="text-[#123B5D] text-lg font-gill text-lg">
                                        Executive Council
                                    </span>
                                </div>

                                {/* <p className="uppercase tracking-[0.25em] text-sm text-[var(--saffron)] font-gill mb-4">
                    Kumaun University
                </p> */}

                                <h1 className="text-4xl md:text-4xl font-bold leading-tight text-[#064E3B] font-gill text-lg">
                                    Executive Council
                                </h1>

                                {/* <p className="mt-5 text-lg text-[#123B5D] max-w-2xl">
                    Discover the history, vision, campuses and academic
                    excellence of Kumaun University.
                </p> */}
                            </div>
                        </div>
                    </section>

                    {/* STATS */}


                    {/* ABOUT CONTENT */}
                    <section className="py-16 bg-[#f8faf9]">
                        <div className="max-w-6xl mx-auto px-4">

                            {/* Main Heading */}
                            <div className="mb-0">
                                <div className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
                                    {executiveLoading ? (
                                        <div className="py-6 text-center text-gray-600">
                                            Loading Executive Council...
                                        </div>
                                    ) : executiveError ? (
                                        <div className="py-6 text-center text-red-600">
                                            {executiveError}
                                        </div>
                                    ) : executiveMembers.length === 0 ? null : (
                                        <>
                                            {/* Table Header Title */}
                                            <div className="flex items-center justify-between gap-3 border-b border-red-200 bg-red-50 px-4 py-4 sm:px-6">
                                                <div className="flex items-start gap-3">
                                                    <div className="mt-1 h-6 w-1 shrink-0 rounded-full bg-red-700" />

                                                    <div>
                                                        <h2 className="text-base font-bold leading-6 text-red-900 sm:text-lg">
                                                            Executive Council
                                                        </h2>

                                                        <p className="mt-1 text-xs text-gray-500">
                                                            Executive Council — Member Details
                                                        </p>
                                                    </div>
                                                </div>

                                                <span className="shrink-0 rounded-full border border-red-200 bg-white px-3 py-1 text-xs font-semibold text-red-800">
                                                    {executiveMembers.length} Members
                                                </span>
                                            </div>

                                            {/* Single Table */}
                                            <div className="overflow-x-auto">
                                                <table className="w-full min-w-[650px] border-collapse text-sm">
                                                    <thead>
                                                        <tr className="bg-[#17365D] text-white">
                                                            <th className="w-16 border-r border-white/20 px-4 py-3 text-center font-semibold">
                                                                S.No.
                                                            </th>

                                                            <th className="border-r border-white/20 px-4 py-3 text-left font-semibold">
                                                                Name of Member
                                                            </th>

                                                            <th className="border-r border-white/20 px-4 py-3 text-left font-semibold">
                                                                Designation
                                                            </th>

                                                            <th className="border-r border-white/20 px-4 py-3 text-left font-semibold">
                                                                Academic Council Composition
                                                            </th>

                                                            <th className="px-4 py-3 text-left font-semibold">
                                                                University / Campus
                                                            </th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {executiveMembers.map((member, index) => (
                                                            <tr
                                                                key={member.id ?? index}
                                                                className="border-b border-gray-200 last:border-b-0 even:bg-gray-50 hover:bg-red-50/70"
                                                            >
                                                                <td className="border-r border-gray-100 px-4 py-3 text-center text-gray-500">
                                                                    {index + 1}
                                                                </td>

                                                                <td className="border-r border-gray-100 px-4 py-3 font-semibold text-gray-800">
                                                                    {member.name || ""}
                                                                </td>

                                                                <td className="border-r border-gray-100 px-4 py-3 text-gray-700">
                                                                    {member.designation || ""}
                                                                </td>

                                                                <td className="border-r border-gray-100 px-4 py-3 text-gray-700">
                                                                    {member.member_section || ""}
                                                                </td>

                                                                <td className="px-4 py-3 text-gray-700">
                                                                    {member.campus || ""}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>

                                            {/* Footer */}
                                            <div className="border-t border-gray-100 bg-gray-50 px-4 py-2 text-right text-xs text-gray-500">
                                                Total Executive Council Members: {executiveMembers.length}
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>





                        </div>

                    </section>

                    <Footer />

                </div>
            );


        case "finance-committee":
            return (
                <div className="min-h-screen bg-[var(--paper)]">
                    <Header />
                    {/* HERO */}
                    <section className="relative h-[250px] overflow-hidden">
                        <img src="/images/campusKumaun.avif" alt="Kumaun University"
                            className="absolute inset-0 w-full h-full object-cover" />

                        {/* Overlay */}
                        <div className="absolute inset-0 bg-gradient-to-r from-[#d1fae5]/95 via-[#a7f3d0]/80 to-[#ecfdf5]/40" />
                        <div className="relative z-10 max-w-7xl mx-auto h-full px-6 flex items-center">
                            <div className="max-w-3xl text-white">

                                {/* Breadcrumb */}
                                <div className="flex items-center gap-2 text-sm text-white/70 mb-5">
                                    {/* <span>Home</span> */}
                                    {/* <span>/</span> */}
                                    <span className="text-[#123B5D] text-lg font-gill">
                                        About
                                    </span>

                                    <span className="text-[#123B5D] text-lg font-gill">
                                        /
                                    </span>

                                    <span className="text-[#123B5D] text-lg font-gill">
                                        FINANCE COMMITTEE
                                    </span>
                                </div>

                                {/* <p className="uppercase tracking-[0.25em] text-sm text-[var(--saffron)] font-gill mb-4">
                    Kumaun University
                </p> */}

                                <h1 className="text-4xl md:text-4xl font-bold leading-tight text-[#064E3B] font-gill">
                                    Finance Committee
                                </h1>

                                {/* <p className="mt-5 text-lg text-[#123B5D] max-w-2xl">
                    Discover the history, vision, campuses and academic
                    excellence of Kumaun University.
                </p> */}
                            </div>
                        </div>
                    </section>

                    {/* STATS */}


                    {/* ABOUT CONTENT */}
                    <section className="py-16 bg-[#f8faf9]">
                        <div className="max-w-6xl mx-auto px-4">

                            {/* Main Heading */}
                            <div className="text-center mb-0">
                                {/* <span
                    className="inline-block px-4 py-1.5 rounded-full bg-[#e7f3ed] text-[#176b4d] text-sm font-gill mb-4">
                    UNIVERSITY COURT
                </span> */}

                                {/* <h2 className="text-3xl md:text-4xl font-bold text-[#123c5a]">
                    The Court shall consist of the following members, namely—
                </h2> */}

                                {/* <div className="w-20 h-1 bg-[#d6a84f] mx-auto mt-4 rounded-full"></div> */}
                            </div>





                            {/* Class II */}
                            <div className="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-7">

                                <div className="flex items-center gap-4 bg-gradient-to-r from-[#067a23] to-[#1c607d] px-2 py-2">


                                    <div>
                                        <h3 className="text-xl md:text-1xl font-bold text-white font-gill">
                                            The Finance Committee shall consist of-
                                        </h3>

                                    </div>
                                </div>

                                <div className="p-2 md:p-2">

                                    <div className="space-y-4 font-gill text-lg">

                                        {[
                                            "The Vice-Chancellor.",

                                            "The Secretary to the State Government in the Higher Education Department.",
                                            "The Secretary to the State Government in the Finance Department.",
                                            "The Pro-Vice-Chancellor, if any.",
                                            "The Registrar.",
                                            "The Controller of Examinations.",
                                            "One person, not being a member of the Executive Council or the Academic Council or a person in the service of the University or an Institute or of a constituent college, or a member of the Managing Committee of any affiliated or associated college, or a person in the service of such college, to be elected by the Executive Council.",
                                            "The Finance Officer who shall also be the Secretary of the Committee.",



                                        ].map((item, index) => (
                                            <div key={index}
                                                className="group flex items-start gap-4 p-4 rounded-xl bg-[#f8faf9] border border-gray-100 hover:border-[#d6a84f] hover:bg-[#fffdf7] transition-all duration-300">

                                                <div
                                                    className="flex-shrink-0 w-8 h-8 rounded-lg bg-[#176b4d] text-white flex items-center justify-center font-gill group-hover:bg-[#d6a84f] transition">
                                                    {index + 1}
                                                </div>

                                                <p className="text-gray-700 leading-7 pt-0.5">
                                                    {item}
                                                </p>

                                            </div>
                                        ))}

                                    </div>
                                </div>
                            </div>

                        </div>

                    </section>
                    <Footer />


                </div>
            );

        case "vision-mission-strategy":
            return (
                <div className="min-h-screen bg-[var(--paper)]">
                    <Header />
                    {/* HERO */}
                    <section className="relative h-[250px] overflow-hidden">
                        <img src="/images/campusKumaun.avif" alt="Kumaun University"
                            className="absolute inset-0 w-full h-full object-cover" />

                        {/* Overlay */}
                        <div className="absolute inset-0 bg-gradient-to-r from-[#d1fae5]/95 via-[#a7f3d0]/80 to-[#ecfdf5]/40" />
                        <div className="relative z-10 max-w-7xl mx-auto h-full px-6 flex items-center">
                            <div className="max-w-3xl text-white">

                                {/* Breadcrumb */}
                                <div className="flex items-center gap-2 text-sm text-white/70 mb-5">
                                    {/* <span>Home</span> */}
                                    {/* <span>/</span> */}
                                    <span className="text-[#123B5D] text-lg font-gill">
                                        About
                                    </span>

                                    <span className="text-[#123B5D] text-lg font-gill">
                                        /
                                    </span>

                                    <span className="text-[#123B5D] text-lg font-gill">
                                        Vision Mission And Strategy
                                    </span>
                                </div>

                                {/* <p className="uppercase tracking-[0.25em] text-sm text-[var(--saffron)] font-gill mb-4">
                    Kumaun University
                </p> */}

                                <h1 className="text-4xl md:text-4xl font-bold leading-tight text-[#064E3B] font-gill">
                                    VISION, MISSION & STRATEGY
                                </h1>

                                {/* <p className="mt-5 text-lg text-[#123B5D] max-w-2xl">
                    Discover the history, vision, campuses and academic
                    excellence of Kumaun University.
                </p> */}
                            </div>
                        </div>
                    </section>
                    {/* HIGHLIGHTS */}
                    <section className="bg-white py-20">
                        <div className="max-w-7xl mx-auto px-6">

                            <div className="text-center max-w-1xl mx-auto mb-12">



                            </div>

                            <div className="grid md:grid-cols-3 gap-6">

                                {/* ================= VISION ================= */}
                                <div
                                    className="group relative bg-white rounded-2xl p-8
                  border border-gray-200 shadow-md
                  hover:shadow-xl transition-all duration-300
                  overflow-hidden">

                                    {/* Decorative Shape */}
                                    <div
                                        className="absolute -top-10 -left-10 w-32 h-32
                    rounded-full bg-[#EAF5EF]
                    group-hover:bg-[#D9EFE5]
                    transition-all duration-300">
                                    </div>

                                    {/* Icon */}
                                    <div className="relative w-40 h-36 mb-7 flex items-center justify-center">

                                        <div
                                            className="absolute inset-0 rounded-full
                      bg-[#EAF5EF]
                      group-hover:bg-[#0B5D3B]
                      transition-all duration-300
                      shadow-sm group-hover:shadow-lg">
                                        </div>

                                        <img src="/images/vision-1.png" alt="Vision"
                                            className="relative w-32 h-32 object-contain
                   transition-all duration-300
                   group-hover:scale-110
                   group-hover:brightness-0
                   group-hover:invert" />
                                    </div>

                                    <h3
                                        className="text-xl font-bold text-[#123B5D] mb-4
                   group-hover:text-[#0B5D3B] transition-colors">
                                        VISION
                                    </h3>

                                    <p className="text-gray-600 leading-7 text-justify font-gill text-lg">
                                        Our vision is to become a globally acclaimed institution
                                        committed to excellence in education, research, and innovation,
                                        while fostering comprehensive growth and cultivating socially
                                        conscious global leaders. We aim to equip individuals with the
                                        skills and responsibility necessary to thrive as citizens.
                                        Transparency and accountability will be fundamental principles
                                        in our governance policies, ensuring integrity and trust.
                                        Additionally, we will adhere to quality assurance standards
                                        aligned with the best practices of higher education,
                                        guaranteeing the delivery of excellence in all aspects of
                                        our institution.
                                    </p>

                                </div>


                                {/* ================= MISSION ================= */}
                                <div
                                    className="group relative bg-white rounded-2xl p-8
                  border border-gray-200 shadow-md
                  hover:shadow-xl transition-all duration-300
                  overflow-hidden">

                                    {/* Decorative Shape */}
                                    <div
                                        className="absolute -top-10 -left-10 w-32 h-32
                    rounded-full bg-[#EAF5EF]
                    group-hover:bg-[#D9EFE5]
                    transition-all duration-300">
                                    </div>

                                    {/* Icon */}
                                    <div className="relative w-40 h-36 mb-7 flex items-center justify-center">

                                        <div
                                            className="absolute inset-0 rounded-full
                      bg-[#EAF5EF]
                      group-hover:bg-[#0B5D3B]
                      transition-all duration-300
                      shadow-sm group-hover:shadow-lg">
                                        </div>

                                        <img src="/images/mission.png" alt="Mission"
                                            className="relative w-32 h-32 object-contain
                   transition-all duration-300
                   group-hover:scale-110
                   group-hover:brightness-0
                   group-hover:invert" />
                                    </div>

                                    <h3
                                        className="text-xl font-bold text-[#123B5D] mb-4
                   group-hover:text-[#0B5D3B] transition-colors font-gill">
                                        MISSION
                                    </h3>

                                    <p className="text-gray-600 leading-7 text-justify font-gill text-lg">
                                        Our mission encompasses several key objectives: Firstly, we aim
                                        to provide transformative education that equips students with
                                        the knowledge and skills needed to tackle real-world challenges
                                        effectively. Secondly, we strive to push the boundaries of
                                        knowledge through influential research that addresses societal
                                        issues and contributes to the progress of our country. Thirdly,
                                        we are committed to fostering an inclusive and diverse learning
                                        environment that promotes cultural understanding, ethical values,
                                        and a lifelong passion for learning. Lastly, our goal is to
                                        produce graduates who are professionally and personally developed,
                                        possessing both theoretical knowledge and practical skills,
                                        thereby enabling them to excel in their chosen fields and make
                                        positive contributions to society.
                                    </p>

                                </div>


                                {/* ================= CORE VALUE ================= */}
                                <div
                                    className="group relative bg-white rounded-2xl p-8
                  border border-gray-200 shadow-md
                  hover:shadow-xl transition-all duration-300
                  overflow-hidden">

                                    {/* Decorative Shape */}
                                    <div
                                        className="absolute -top-10 -left-10 w-32 h-32
                    rounded-full bg-[#EAF5EF]
                    group-hover:bg-[#88bfe1]
                    transition-all duration-300">
                                    </div>

                                    {/* Icon */}
                                    <div className="relative w-40 h-36 mb-7 flex items-center justify-center">

                                        <div
                                            className="absolute inset-0 rounded-full
                      bg-[#EAF5EF]
                      group-hover:bg-[#0B5D3B]
                      transition-all duration-300
                      shadow-sm group-hover:shadow-lg">
                                        </div>

                                        <img src="/images/core-value-2.png" alt="Core Value"
                                            className="relative w-[200px] h-[200px] object-contain
                            transition-all duration-300
                            group-hover:scale-110
                            group-hover:brightness-0
                            group-hover:invert" />
                                    </div>

                                    <h3
                                        className="text-xl font-bold text-[#123B5D] mb-4
                   group-hover:text-[#0B5D3B] transition-colors font-gill">
                                        CORE-VALUE
                                    </h3>

                                    <p className="text-gray-600 leading-7 text-justify font-gill text-lg">
                                        Our focus areas encompass various critical aspects: Firstly,
                                        we are dedicated to promoting gender equality and empowering
                                        women within our institution and broader society. Secondly,
                                        we prioritize e-governance and efficient administration to
                                        streamline processes and enhance organizational effectiveness.
                                        Thirdly, we are committed to implementing green practices to
                                        minimize our environmental impact and contribute to sustainability
                                        efforts. Lastly, we emphasize cultural and religious tolerance
                                        and harmony, fostering an inclusive and respectful community
                                        where diversity is celebrated and valued.
                                    </p>

                                </div>

                            </div>
                        </div>
                    </section>
                    <Footer />

                </div>
            );
        case "campus":
            return (
                <div className="min-h-screen bg-[var(--paper)]">
                    <Header />

                    {/* HERO */}
                    <section className="relative h-[300px] overflow-hidden font-gill">
                        <img src="/images/campusKumaun.avif" alt="Kumaun University"
                            className="absolute inset-0 w-full h-full object-cover" />

                        {/* Overlay */}
                        <div className="absolute inset-0 bg-gradient-to-r from-[#d1fae5]/95 via-[#a7f3d0]/80 to-[#ecfdf5]/40" />
                        <div className="relative z-10 max-w-7xl mx-auto h-full px-6 flex items-center">
                            <div className="max-w-3xl text-white">

                                {/* Breadcrumb */}
                                <div className="flex items-center gap-2 text-sm text-white/70 mb-5">
                                    {/* <span>Home</span> */}
                                    {/* <span>/</span> */}
                                    <span className="text-[#123B5D] text-lg font-gill">
                                        About
                                    </span>

                                    <span className="text-[#123B5D] text-lg font-gill">
                                        /
                                    </span>

                                    <span className="text-[#123B5D] text-lg font-gill">
                                        Campus
                                    </span>
                                </div>

                                {/* <p className="uppercase tracking-[0.25em] text-sm text-[var(--saffron)] font-semibold mb-4">
                    Kumaun University
                </p> */}

                                <h1 className="text-4xl md:text-6xl font-bold leading-tight text-[#064E3B] font-gill">
                                    UNIVERSITY CAMPUS
                                </h1>

                                {/* <p className="mt-5 text-lg text-[#123B5D] max-w-2xl text-justify">
                    Discover the history, vision, campuses and academic
                    excellence of Kumaun University.
                </p> */}
                            </div>
                        </div>
                    </section>

                    {/* STATS */}

                    {/* ABOUT CONTENT */}
                    <section className="max-w-7xl mx-auto px-6 py-20">
                        <div className="grid lg:grid-cols-2 gap-14 items-center">

                            {/* IMAGE */}
                            <div className="relative">
                                <div className="absolute -left-5 -bottom-5 w-full h-full rounded-3xl bg-[var(--saffron)]/20" />

                                <img src="/images/DSB-campus-nainital.jpg" alt="Kumaun University Campus"
                                    className="relative w-full h-[430px] object-cover rounded-3xl shadow-xl" />
                            </div>

                            {/* CONTENT */}
                            <div>
                                <h3 className="uppercase tracking-[0.2em] text-sm font-bold text-[var(--ink)] mb-3 font-gill">
                                    DSB Campus Nainital
                                </h3>

                                {/* <h2 className="text-3xl md:text-4xl font-bold text-[var(--ink)] mb-6">
                    UNIVERSITY AT A GLANCE
                </h2> */}

                                <p className="text-gray-600 leading-8 mb-5 text-justify font-gill text-lg">
                                    Kumaun University-DSB Campus provides a wide range of undergraduate and postgraduate courses for
                                    students to choose from. There is a total of 29 courses provided in various fields of
                                    specialisations such as Science, Arts, Management, Commerce, Mass Communications, Medical, Law,
                                    Pharmacy, Computer Applications and much more.
                                </p>
                                <div className="flex items-start gap-3">
                                    <i className="fa-solid fa-phone text-[#E52323] text-[17px] mt-1 w-4"></i>
                                    <p>9412427965</p>
                                </div>
                                <div className="flex items-center gap-2">
                                    <MapPin size={22} className="text-[#E52323] text-[17px]" />
                                    <span className="font-gill text-lg">9FM5+6F6, Ayarpatta, Nainital, Uttarakhand 263002</span>
                                </div>
                                {/* Button - Text ke just niche */}
                                <div className="mt-4 font-gill text-lg">
                                    <a href="/" target="_blank" rel="noopener noreferrer"
                                        className="inline-flex items-center px-5 py-2.5 rounded-lg bg-[#B5121B] text-white font-semibold text-sm hover:opacity-90 transition">
                                        Courses/Programs
                                        <ArrowRight size={17} />
                                    </a>
                                </div>

                            </div>

                        </div>
                    </section>

                    <section className="max-w-7xl mx-auto px-6 py-20">
                        <div className="grid lg:grid-cols-2 gap-14 items-center">

                            {/* IMAGE */}
                            <div className="relative">
                                <div className="absolute -left-5 -bottom-5 w-full h-full rounded-3xl bg-[var(--saffron)]/20" />

                                <img src="/images/jc-bose-campus-bhimtal.jpeg" alt="Kumaun University Campus"
                                    className="relative w-full h-[430px] object-cover rounded-3xl shadow-xl" />
                            </div>

                            {/* CONTENT */}
                            <div>
                                <h3 className="uppercase tracking-[0.2em]  font-bold text-[var(--ink)] mb-3 font-gill text-lg">
                                    Sir J.C. Bose Technical Campus Bhimtal
                                </h3>

                                {/* <h2 className="text-3xl md:text-4xl font-bold text-[var(--ink)] mb-6">
                    UNIVERSITY AT A GLANCE
                </h2> */}

                                <p className="text-gray-600 leading-8 mb-5 text-justify font-gill text-lg">
                                    Sir J.C. Bose Technical Campus, Bhimtal, Kumaun University, Nainital, a prestigious higher education
                                    institution, was founded in 1997. The institute offers UG and PG Degree programmes for students to
                                    further their studies. These programs are specially designed for Full-Time mode and are approved by
                                    prominent national bodies such as AICTE. The institute offers a variety of courses such as BBM/BMS,
                                    MBA/PGDM, M.Sc, M.Pharma, B.Pharma in major streams including Business & Management Studies,
                                    Science, Medicine & Health Sciences.
                                </p>
                                <div className="flex items-start gap-3">
                                    <i className="fa-solid fa-phone text-[#E52323] text-[17px] mt-1 w-4"></i>
                                    <p>05962-235644</p>
                                </div>
                                <div className="flex items-center gap-2">
                                    <MapPin size={22} className="text-[#E52323] text-[17px]" />
                                    <span className="font-gill text-lg">Block Rd, Bhimtal, Uttarakhand 263136</span>
                                </div>
                                {/* Button - Text ke just niche */}
                                <div className="mt-4 font-gill text-lg">
                                    <a href="/" target="_blank" rel="noopener noreferrer"
                                        className="inline-flex items-center px-5 py-2.5 rounded-lg bg-[#B5121B] text-white font-semibold text-sm hover:opacity-90 transition">
                                        Courses/Programs
                                        <ArrowRight size={17} />
                                    </a>
                                </div>

                            </div>

                        </div>
                    </section>


                    <Footer />

                </div>

            );
 case "colleges-list":
             return (
    <div className="min-h-screen bg-[var(--paper)]">
      <Header />

      {/* ================= HERO ================= */}

      <section className="relative h-[250px] overflow-hidden">
        <img src="/images/campusKumaun.avif" alt="Kumaun University"
            className="absolute inset-0 w-full h-full object-cover" />

        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#d1fae5]/95 via-[#a7f3d0]/80 to-[#ecfdf5]/40" />
        <div className="relative z-10 max-w-7xl mx-auto h-full px-6 flex items-center">
            <div className="max-w-3xl text-white">

                {/* Breadcrumb */}
                <div className="flex items-center gap-2 text-sm text-white/70 mb-5">
                    {/* <span>Home</span> */}
                    {/* <span>/</span> */}
                    <span className="text-[#123B5D] text-lg font-gill">
                        Affiliation
                    </span>

                    <span className="text-[#123B5D] text-lg font-gill">
                        /
                    </span>

                    <span className="text-[#123B5D] text-lg font-gill">
                        Affiliated Colleges
                    </span>
                </div>
                <h1 className="text-4xl md:text-4xl font-bold leading-tight text-[#064E3B] font-gill">
                    Affiliated Colleges
                </h1>

                <p className="mt-5 text-lg text-[#123B5D] max-w-2xl">
                    College code, name, district and type listing under the University.
                </p>
            </div>
        </div>
    </section>

      {/* ================= MAIN CONTENT ================= */}

      <section className="bg-white py-10">
        <div className="max-w-7xl mx-auto px-6">
          {/* PDF LINKS */}

          <div className="flex flex-wrap gap-4 mb-8">
            {PDF_LINKS.map((pdf) => (
              <a
                key={pdf.href}
                href={pdf.href}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 rounded-lg border border-gray-200 px-4 py-3 font-gill text-[16px] text-[#08245c] hover:border-[#8B1E1E] hover:text-[#8B1E1E] transition-colors duration-200"
              >
                <span className="flex h-9 w-8 items-center justify-center rounded bg-[#B5121B] text-[10px] font-bold text-white">
                  PDF
                </span>
                {pdf.label}
              </a>
            ))}
          </div>

          {/* LIST CARD */}

          <div className="rounded-2xl border border-emerald-100 bg-emerald-50/60 p-6">
            <div className="flex flex-wrap items-center justify-between gap-2 mb-5">
              <h2 className="text-3xl font-bold text-[#08245c] font-gill">
                College List
              </h2>

              {!loading && !error && (
                <p className="text-gray-600 font-gill">
                  {filteredColleges.length} of {colleges.length} colleges shown
                </p>
              )}
            </div>

            {/* FILTERS + SEARCH */}

            <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between mb-6">
              <div className="flex flex-wrap gap-3">
                {filters.map((filter) => {
                  const isActive = activeFilter === filter.key;

                  return (
                    <button
                      key={filter.key}
                      type="button"
                      onClick={() => setActiveFilter(filter.key)}
                      className={`rounded-full border px-5 py-2 font-gill text-[15px] font-semibold transition-colors duration-200 ${
                        isActive
                          ? "bg-[#064E3B] border-[#064E3B] text-white"
                          : "bg-white border-gray-200 text-[#08245c] hover:border-[#064E3B]"
                      }`}
                    >
                      {filter.label} ({counts[filter.key]})
                    </button>
                  );
                })}
              </div>

              <div className="relative w-full md:w-80">
                <Search
                  size={18}
                  className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
                />
                <input
                  type="text"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Search by code, college or district..."
                  className="w-full rounded-lg border border-gray-200 bg-white py-3 pl-10 pr-4 font-gill text-[15px] outline-none focus:border-[#064E3B]"
                />
              </div>
            </div>

            {/* TABLE */}

            <div className="overflow-x-auto rounded-lg border border-gray-200 bg-white">
              <table className="w-full min-w-[760px] table-fixed border-collapse font-gill">
                <thead>
                  <tr className="bg-[#064E3B] text-left text-white">
                    <th className="w-[110px] px-6 py-4 text-center text-sm font-bold">
                      COLLEGE CODE
                    </th>
                    <th className="px-6 py-4 text-sm font-bold">COLLEGE NAME</th>
                    <th className="w-[200px] px-6 py-4 text-sm font-bold">
                      COLLEGE DISTT.
                    </th>
                    <th className="w-[160px] px-6 py-4 text-center text-sm font-bold">
                      COLLEGE TYPE
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {loading && (
                    <tr>
                      <td colSpan={4} className="px-6 py-10 text-center text-gray-500">
                        Loading colleges...
                      </td>
                    </tr>
                  )}

                  {!loading && error && (
                    <tr>
                      <td colSpan={4} className="px-6 py-10 text-center text-red-600">
                        {error}
                      </td>
                    </tr>
                  )}

                  {!loading && !error && filteredColleges.length === 0 && (
                    <tr>
                      <td colSpan={4} className="px-6 py-10 text-center text-gray-500">
                        No colleges match your search. Try a different code, name or
                        district.
                      </td>
                    </tr>
                  )}

                  {!loading &&
                    !error &&
                    filteredColleges.map((college, index) => {
                      const typeKey = getTypeKey(college.govt_pvt);

                      return (
                        <tr
                          key={college.id}
                          className={`border-t border-gray-100 ${
                            index % 2 === 1 ? "bg-emerald-50/50" : "bg-white"
                          }`}
                        >
                          <td className="px-6 py-4 text-center font-semibold text-[#08245c]">
                            {college.coll_cd}
                          </td>

                          <td className="px-6 py-4 text-gray-800 uppercase">
                            {college.coll_name}
                          </td>

                          <td className="px-6 py-4 font-semibold text-gray-800 uppercase">
                            {college.dist_name || "-"}
                          </td>

                          <td className="px-6 py-4 text-center">
                            <span
                              className={`inline-block rounded-full border px-4 py-1 text-sm font-semibold ${TYPE_BADGE[typeKey]}`}
                            >
                              {TYPE_LABEL[typeKey]}
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
        
        default:
            return (
                <div className="min-h-screen flex items-center justify-center">
                    <h1 className="text-3xl font-bold">
                        Page Not Found
                    </h1>
                </div>
            );
    }
};


/* STAT COMPONENT */

const Stat = ({ icon, value, label }) => {
    return (
        <div className="p-6 text-center border-b md:border-b-0 md:border-r last:border-0">
            <div className="flex justify-center text-[var(--terracotta)] mb-3">
                {icon}
            </div>

            <div className="text-2xl font-bold text-[var(--ink)]">
                {value}
            </div>

            <div className="text-sm text-gray-500 mt-1">
                {label}
            </div>
        </div>
    );
};


/* HIGHLIGHT COMPONENT */

const Highlight = ({ title, text }) => {
    return (
        <div className="p-7 rounded-2xl border border-[var(--cream-deep)] bg-[var(--paper)] hover:shadow-lg transition">
            <h3 className="text-xl font-bold text-[var(--ink)] mb-3">
                {title}
            </h3>

            <p className="text-gray-600 leading-7">
                {text}
            </p>
        </div>
    );

};

export default AboutPage;
